import React from "react";
import {UserFormCreate} from "../../components/users/UserFormCreate";

export function CreateUserForm() {
    return (
        <UserFormCreate/>
    )
}